// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ColorVariants":"bbv_a bie_i bie_j","ColorVariants__color":"bbv_b bie_rp","ColorVariants__more":"bbv_c bie_vv"};